'use client';

import { Analytics } from '@streetferret/ui-web/analytics';
import { cn } from '@streetferret/utils';
import { useSelectedLayoutSegments } from 'next/navigation';
import * as React from 'react';
import { NavBar } from './nav-bar';
import { PaulFooter } from '../paul-footer';

export function LayoutShell({ children }: { children: React.ReactNode }) {
  const segments = useSelectedLayoutSegments();
  const isTrack = segments[0] === 'track';

  return (
    <div className={cn(!isTrack && 'mb-5')}>
      <NavBar />
      <div className={cn(isTrack ? 'h-[calc(100dvh-55px)] overflow-hidden' : 'min-h-screen')}>
        {children}
      </div>
      {!isTrack ? <PaulFooter /> : null}
      <Analytics siteId="5c7ee9ed-57fb-405d-a4e1-5ce80fbd668a" />
    </div>
  );
}

